import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Desktop, Tablet, Mobile } from 'components/responsive';
import MenuList from './menu-list';
import { menuLinks } from './constants';

import './style.css';

class MainNav extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { mobileMenuActive: false };
  }

  componentWillReceiveProps(nextProps) {
    const { location: nextLocation } = nextProps;
    if (nextLocation) {
      this.setState({ mobileMenuActive: false });
    }
  }

  onClickBurgerButton() {
    const { mobileMenuActive } = this.state;
    this.setState({ mobileMenuActive: !mobileMenuActive });
  }

  render() {
    const { location } = this.props;
    const { mobileMenuActive } = this.state;

    const deskTopLinks = menuLinks.filter(
      m => typeof m.onlyMobile === 'undefined' || m.onlyMobile === false,
    );

    const mobileLinks = menuLinks.filter(
      m => typeof m.onlyMobile === 'undefined' || m.onlyMobile === true,
    );

    return (
      <Fragment>
        <Desktop>
          <nav className="aq-main-nav">
            <MenuList location={location} links={deskTopLinks} />
          </nav>
        </Desktop>
        <Tablet>
          <button
            type="button"
            className={`burger-button ${mobileMenuActive && '-active'}`}
            onClick={() => this.onClickBurgerButton()}
          >
            <span>Menu</span>
          </button>
          {
            mobileMenuActive && (
            <nav className="aq-main-nav-mobile">
              <MenuList location={location} links={mobileLinks} />
            </nav>
            )
          }
        </Tablet>
        <Mobile>
          <button
            type="button"
            className={`burger-button ${mobileMenuActive && '-active'}`}
            onClick={() => this.onClickBurgerButton()}
          >
            <span>Menu</span>
          </button>
          {
            mobileMenuActive && (
            <nav className="aq-main-nav-mobile">
              <MenuList location={location} links={mobileLinks} />
            </nav>
            )
          }
        </Mobile>
      </Fragment>
    );
  }
}

MainNav.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
};

const mapStateToProps = state => ({ user: state.authentication.user });

export default withRouter(connect(mapStateToProps)(MainNav));



// WEBPACK FOOTER //
// ./src/app/main-nav/index.js